module.exports = __webpack_public_path__ + "img/icon_web04_culture3@2x.c97ec3a8.png";